module.exports = __webpack_public_path__ + "img/iPhone-app-icon-step-1.84a3b315.png";